import React, { useState, useEffect } from 'react';
import HotelForm from './Hotels/HotelForm';
import HotelTable from './Hotels/HotelTable';
import '../../Css/AjouterHotel.css'; // Import the CSS file

const AjouterHotel = () => {
  const [hotels, setHotels] = useState([]);
  const [editHotel, setEditHotel] = useState(null);
  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem('token'); 

  useEffect(() => {
    fetchHotels();
  }, []);

  const fetchHotels = async () => {
    try {
      const response = await fetch(`${apiUrl}/api/hotel/liste`, {
        headers: { 'Authorization': `Bearer ${token}`},
      });

      console.log("responseeee",response);
      
      if (!response.ok) {
        throw new Error('Failed to fetch hotels');
      }
  
      const data = await response.json();
      console.log("dataaaaa",data);
  
      if (Array.isArray(data)) {
        setHotels(data);
      } else {
        console.error('Fetched data is not an array', data);
        setHotels([]);
      }
    } catch (error) {
      console.error('Error fetching hotels:', error);
      setHotels([]); 
    }
  };
  

  const addHotel = (newHotel) => {
    setHotels((prevHotels) => [...prevHotels, newHotel]);
  };

  const updateHotel = (updatedHotel) => {
    setHotels((prevHotels) => 
      prevHotels.map(hotel =>
        hotel.id === updatedHotel.id ? updatedHotel : hotel
      )
    );
  };

  const handleEdit = (hotel) => {
    window.scrollTo(0, 0); // Scroll to the top of the page
    setEditHotel(hotel);
  };


  return (
    <div className="hotel-page">
      <section>
        <HotelForm 
          onAddHotel={addHotel} 
          editHotel={editHotel} 
          onUpdateHotel={updateHotel}
          onCancelEdit={() => setEditHotel(null)}
          onFetch={fetchHotels}
        />
      </section>
      <section>
        <HotelTable 
          hotels={hotels} 
          onEdit={handleEdit}
          onFetch={fetchHotels}
        />
      </section>
    </div>
  );
};

export default AjouterHotel;
